module.exports = __webpack_public_path__ + "static/fonts/Futura Condensed ExtraBold.3c3975e1.ttf";